import { render, staticRenderFns } from "./changeUserPassword.vue?vue&type=template&id=d83e0358&"
import script from "./changeUserPassword.vue?vue&type=script&lang=js&"
export * from "./changeUserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports